import React from "react";
import {
  FaTiktok,
  FaSnapchatGhost,
  FaWhatsapp,
  FaInstagram,
} from "react-icons/fa";
import "./App.css";

function Footer() {
  return (
    <footer className="footer">
      <div className="footer-icons">
        <a href="https://www.tiktok.com/@floriakwt?_t=8nV2EMSFgQ5&_r=1" target="_blank" rel="noreferrer">
          <FaTiktok />
        </a>
        <a href="https://www.snapchat.com/add/Floriakwt" target="_blank" rel="noreferrer">
          <FaSnapchatGhost />
        </a>
        <a href="https://api.whatsapp.com/send/?phone=96594432382" target="_blank" rel="noreferrer">
          <FaWhatsapp />
        </a>
        <a href="https://www.instagram.com/floriakwt" target="_blank" rel="noreferrer">
          <FaInstagram />
        </a>
      </div>
      <a href="https://www.instagram.com/tangle.io/" target="_blank" rel="noreferrer">
        <p className="footer-text" style={{ color: "white" }}>
          © 2025 Tangle Company, all rights reserved.
        </p>
      </a>
      
    </footer>
  );
}

export default Footer;
